module.exports = __webpack_public_path__ + "static/media/google_sheets_logo.2bf1854c.png";